import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="py-16 md:py-24 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="text-center">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-light tracking-tight text-foreground/10 mb-8 select-none">
            JUST BE
          </h2>
          <div className="flex items-center justify-center gap-6 mb-8">
            <a
              href="https://www.skynculture.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-['Outfit'] tracking-[0.15em] uppercase text-muted-foreground hover:text-primary transition-colors"
              data-testid="footer-skyn-link"
            >
              SKYN CULTURE
            </a>
            <span className="w-1 h-1 rounded-full bg-primary" />
            <a
              href="https://sisterdiamonds.com/costa-rica-retreat?ref=ANTONIO"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-['Outfit'] tracking-[0.15em] uppercase text-muted-foreground hover:text-primary transition-colors"
              data-testid="footer-sister-diamonds-link"
            >
              Sister Diamonds
            </a>
          </div>
          <p className="text-xs font-['Outfit'] text-muted-foreground/50 flex items-center justify-center gap-1">
            Curated with <Heart strokeWidth={1} size={12} className="text-primary" /> in Atlanta
          </p>
        </div>
      </div>
    </footer>
  );
}
